export function loanReducer(state = {
    ALL: {},
    BY_EQUIPEMENT: {},
    BY_USER: {},
    DEMANDS: {},
    USER: {}
} ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_LOAN":            
        case "UPDATE_LOAN":
            let list = Object.assign({}, state);
            
            if (list.BY_EQUIPEMENT[payload.loan_equipement]){
                list.ALL[payload.loan_id] = payload
                Object.assign(list.BY_EQUIPEMENT[payload.loan_equipement], {[payload.loan_id]: payload})
            }

            return list
            
        case "GET_LOANS":
            let list2 = Object.assign({}, state);
            list2.ALL = payload
        
            return list2
            
        case "GET_USER_LOANS":
            let list3 = Object.assign({}, state);
            list3.USER = payload
        
            return list3

        case "GET_EQUIPEMENT_LOANS":
            let list4 = Object.assign({}, state);

            list4.BY_EQUIPEMENT[payload.equipementID] = payload.list
            list4.ALL = Object.assign(list4.ALL, payload.list)
        
            return list4

        case "GET_USER_LOANS_ADMIN":
            let list5 = Object.assign({}, state);
            list5.BY_USER[payload.userID] = payload.list
            list5.ALL = Object.assign(list5.ALL, payload.list)
        
            return list5

        // case "GET_USER_LOAN_DEMANDS":
        //     let list6 = Object.assign({}, state);
        //     list6.DEMANDS = payload.list
        //     // list6.DEMANDS[payload.userID] = payload.list
        
        //     return list6
        
        default:
            return state;
    }
    
}